import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Solution() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-[#2F4538] text-[#F5F0E8] relative overflow-hidden" data-id="element-417">
      <div className="absolute inset-0 opacity-10" data-id="element-418">
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#B4A7D6] rounded-full blur-[120px]" data-id="element-419"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#D4AF37] rounded-full blur-[120px]" data-id="element-420"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-421">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-422">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-12 text-[#D4AF37]" data-id="element-423">
            Imaginá esto...
          </h2>
        </motion.div>

        <div className="space-y-8 mb-16 text-lg sm:text-xl leading-relaxed text-[#F5F0E8]/90 font-light" data-id="element-424">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex gap-4" data-id="element-425">
            <span className="text-3xl shrink-0" data-id="element-426">💧</span>
            <p data-id="element-427">
              <strong className="text-[#F5F0E8] font-semibold" data-id="element-428">
                Llegás a tu casa después de un día pesado.
              </strong>{' '}
              En vez de tirarte en el sofá a scrollear el celular sin ganas de
              nada, te preparás un ritual de pies.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex gap-4" data-id="element-429">
            <span className="text-3xl shrink-0" data-id="element-430">🌿</span>
            <p data-id="element-431">
              Ponés agua tibia, un puñado de sal gruesa, unas hojas de romero
              (que tenías en la cocina), y te sentás. Metés los pies en el agua.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex gap-4" data-id="element-432">
            <span className="text-3xl shrink-0" data-id="element-433">✨</span>
            <p data-id="element-434">
              <strong className="text-[#D4AF37] font-semibold" data-id="element-435">
                Y en 10 minutos sentís cómo TODO el peso del día se empieza a
                ir.
              </strong>{' '}
              Tu cuerpo se relaja. Tu mente se calma. Es como si te sacaran una
              mochila invisible de los hombros.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex gap-4" data-id="element-436">
            <span className="text-3xl shrink-0" data-id="element-437">🌸</span>
            <p data-id="element-438">
              Repetís esto 2-3 veces por semana. Y de a poco, empezás a notar:
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="bg-white/5 backdrop-blur-sm p-8 sm:p-10 rounded-3xl border border-[#D4AF37]/20 mb-16" data-id="element-439">
          <ul className="space-y-4" data-id="element-440">
            {['Dormís mejor (te despertás descansada de verdad)', 'Bajó tu nivel de ansiedad (ya no vivís con el pecho apretado)', 'Tu casa se siente más liviana (menos discusiones, mejor energía)', 'Te sentís más fuerte emocionalmente (como que recuperaste TU poder)'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-441">
                <CheckCircle2 className="w-6 h-6 text-[#D4AF37] shrink-0 mt-1" data-id="element-442" />
                <span className="text-lg sm:text-xl text-[#F5F0E8]" data-id="element-443">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="text-center" data-id="element-444">
          <p className="text-2xl font-bold text-[#B4A7D6] mb-6" data-id="element-445">
            Esto NO es fantasía.
          </p>
          <p className="text-xl text-[#F5F0E8]/90 mb-8" data-id="element-446">
            Esto es lo que pasa cuando usás rituales ancestrales de forma
            CONSISTENTE.
          </p>

          <div className="inline-block bg-black/20 p-6 rounded-2xl border border-white/5 text-left" data-id="element-447">
            <p className="font-bold text-[#D4AF37] mb-4 uppercase tracking-wider text-sm" data-id="element-448">
              Y lo mejor de todo:
            </p>
            <ul className="space-y-2 text-[#F5F0E8]/80" data-id="element-449">
              <li data-id="element-450">👉 No necesitás creer en nada raro</li>
              <li data-id="element-451">👉 No necesitás ser "espiritual"</li>
              <li data-id="element-452">👉 No necesitás ingredientes caros</li>
            </ul>
            <p className="mt-6 font-medium text-[#F5F0E8]" data-id="element-453">
              Solo necesitás 10 minutos, agua tibia, y seguir el sistema.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}